import React from 'react';
import { PageSubTitle } from 'Components/Titles';
import { SecondaryText } from 'Components/Texts';
import { RestartPlanChurned } from 'Features/MyAccount/RestartPlanChurned';
import { useStore } from 'Hooks/useStore';
import { isAllowingChurnedRestart } from 'Utils/Subscriptions';

/**
 * this component will take care the MVPD, iOS and Android direct purchase message
 * @param {*} param
 */
export const AppPurchaseSubscription = ({
  subTitle,
  purchaseType,
  subscription,
  onRestartPlan,
  trackEditAccount,
  isRestartingSubscription,
}) => {
  const { restartChurnedUserDetails = {}, validityTill } = subscription;
  const { getPlansSuccess } = useStore('plans');

  const PURCHASE_TYPE_MESSAGES = {
    ios: 'To manage your subscription, please use your Apple device, navigate to "Settings" then "Subscriptions".',
    android: 'To manage your subscription, please visit the Google Play Store, then "Payments and Subscriptions".',
    verizonBango: 'To manage your subscription, please visit Verizon +play.',
    siriusXMBango: 'To manage your subscription, please visit SiriusXM.',
    samsung: 'To manage your subscription, please go to your Samsung Checkout account.',
    roku: "To manage your subscription, please go to Roku's account management.",
    amazon: 'To manage your subscription, please go to your Amazon account.',
  };
  const configMessage = PURCHASE_TYPE_MESSAGES[purchaseType];

  const isChurnedRestartAllowed = isAllowingChurnedRestart(subscription);
  const showChurnedRestart = isChurnedRestartAllowed && getPlansSuccess;

  if (configMessage || isChurnedRestartAllowed)
    return (
      <div className="sectionFlex membershipSection" data-testid="appPurchaseSubscription">
        <div className="flexGrowOne settingsSectionLeft">
          <PageSubTitle text={subTitle} />
        </div>
        <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
          <div className="sectionFlex flexDirCol">
            {configMessage && !showChurnedRestart && <SecondaryText className="noMargin" text={configMessage} />}
            {showChurnedRestart && (
              <div className={`sectionFlex ${!configMessage ? 'noMessage' : ''}`}>
                <RestartPlanChurned {...restartChurnedUserDetails} validityTill={validityTill} />
                <span
                  role="button"
                  className="profileLink restartChurnedPlan"
                  onClick={() => {
                    if (isRestartingSubscription) return;
                    onRestartPlan();
                    trackEditAccount('Resubscribe');
                  }}
                >
                  Resubscribe
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  return null;
};
